import * as types from './mutation-types'

export default {
  
  [types.SET_CASH_REGISTERS](state, cashRegisters) {
    state.cashRegisters = cashRegisters
  },

  
  [types.ADD_CASH_REGISTER](state, newRegister) {
    state.cashRegisters.push(newRegister)
  },

 
  [types.UPDATE_CASH_REGISTER](state, updatedRegister) {
    const index = state.cashRegisters.findIndex(item => item.id === updatedRegister.id)
    if (index !== -1) {
      state.cashRegisters.splice(index, 1, updatedRegister)
    }
  },

  
  [types.DELETE_CASH_REGISTER](state, registerId) {
    state.cashRegisters = state.cashRegisters.filter(item => item.id !== registerId)
  }
}